export default __webpack_public_path__ + "static/media/43_2_3.51fee1bf.png";